import cn from "classnames";
import PanelTemplate from "components/shared/profile/panel";
import React from "react";
import { config, initialState } from "./config";

class CurrencySettings extends PanelTemplate {
    renderBody = () => {
        const { editable, config } = this.props;
        const { currency } = config;
        return this.renderSelect({ ...currency, disabled: !editable });
    };

    render() {
        const cname = cn("card card-body mb-3", {
            "border-danger": !this.state.isValid,
        });
        return (
            <div className={cname}>
                <div className="row">
                    <div className="col-sm-4">
                        <h5>Валюта организации</h5>
                    </div>
                    <div className="col-sm-8">
                        {this.renderBody()}
                        {this.renderButton()}
                    </div>
                </div>
            </div>
        );
    }
}

const ConfiguredPanel = (props) => <CurrencySettings {...props} config={config} initialState={initialState} />;

export default ConfiguredPanel;
